




















import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  props: {
    message: {
      type: String,
      default: '',
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const formatMessage = (message?: string) => {
      return message
        ?.replace(/(\r|\r\n)/g, '\n')
        .split(/\n/)
        .join('<br />');
    };
    return { formatMessage };
  },
});
